import { render, staticRenderFns } from "./PaginaCedolini.vue?vue&type=template&id=35ae49e7"
import script from "./PaginaCedolini.vue?vue&type=script&lang=js"
export * from "./PaginaCedolini.vue?vue&type=script&lang=js"
import style0 from "./PaginaCedolini.vue?vue&type=style&index=0&id=35ae49e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports